module.exports = __webpack_public_path__ + "img/faqs_layout5.cf7189be.png";